'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-show.routes';

export class PropertyShowComponent {
  constructor($stateParams, PropertyService, $uibModal, $window, $state, SettingsService, ContactService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.propertyId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$state = $state;

    this.ContactService = ContactService;
    this.SettingsService = SettingsService;

    SettingsService.getByName({name: 'client'}, settings => {
      this.optInOutRequired = settings.data.optInOut && settings.data.optInOut.required;
      if (this.optInOutRequired) {
        this.optInOutSettings = settings.data.optInOut;
      }

      this.weightVisible = settings.data.weightVisible;

      SettingsService.getByName({name: 'config.app'}, settings => {
        let ssDT = settings.data.serverSideDT || {};
        this.serverSideDT = ssDT && ssDT.contacts && ssDT.contacts.enabled;

        let schemaName = (this.weightVisible) ? "evoting" : "evoting-no-weight";
        this.eVotingSchema = require('../../../components/schemas/' + schemaName + ".json");

        if (this.serverSideDT)
          this.eVotingSchema.properties.voter["x-schema-form"].type = "entitylookup-nodropdown"; // for SS contact lookup
      });
    });

    this.ownerDropdownMenu = [{
      title: 'Add Primary Owner',
      action: _ => {
        this.openAddContactModal('primary-owner');
      }
    },{
      title: 'Add Owner',
      action: _ => {
        this.openAddContactModal('owner');
      }
    },{
      title: 'Change Owner(s)',
      action: _ => {
        this.openEditContactsModal()
      }
    }];

    this.PropertyService = PropertyService;
    this.refreshData();
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.firstName)
      composedName += contact.firstName;

    if (contact.middleName)
      composedName += " " + contact.middleName;

    if (contact.lastName)
      composedName += " " + contact.lastName;

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += ", " + contact.company;

    }

    return composedName;
  }

  openEFormResultModal(eFormResultId) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'eFormResultModal',
      resolve: {
        config: function(){
          return {
            eFormId: that.optInOutSettings.optInForm,
            eFormResultId: eFormResultId
          }
        }
      }
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getSectionTemplate(section) {
    if (!this.customFieldsConfig.sectionTemplate || !this.customFieldsConfig.sectionTemplate[section])
      return null;

    return this.customFieldsConfig.sectionTemplate[section];
  }

  refreshData() {
    if (this.propertyId) {
      this.PropertyService.get({id: this.propertyId}, data => {
        this.property = data;

        if (this.property.eVoting && this.property.eVoting.voter) {
          this.ContactService.get({id: this.property.eVoting.voter}, contact =>{
            this.voter = contact;
          });
        } else {
          this.voter = undefined; // if a previously set voter gets remove
        }

      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  editVoting() {
    var that = this;

    let voterId = (this.voter) ? this.voter._id : "undefined";
    
    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'schemaFormModal',
      resolve: {
        config: function() {
          return {
            title: "Voting",
            icon: "pencil-square-o",
            model: (that.property.eVoting) ? angular.copy(that.property.eVoting) : {},
            schema: that.eVotingSchema,
            dependsOn: (that.serverSideDT) ? ["contact:" + voterId] : ["contacts"]
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (editedEVoting) {
        that.property.eVoting = editedEVoting;

        that.PropertyService.update({id: that.propertyId}, that.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );
  }

  openEditContactsModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'editPropertyContacts',
      size: 'md',
      resolve: {
        config: function() {
          return {
            contacts: that.property.contacts
          }
        }
      }
    });

    modalInstance.result.then(newContacts => {

        that.property.contacts = newContacts;

        that.PropertyService.update({id: that.propertyId}, this.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contacts of property');
        });
      },
      function () { /* cancel */ }
    );

  }

  getAddress(property) {
    try {
      let address = angular.copy(property.address);

      if (!address.street) address.street = "-";
      if (!address.city) address.city = "-";
      if (!address.state) address.state = "-";
      if (!address.zip) address.zip = "-";

      return `${address.street}, ${address.city} ${address.state}, ${address.zip}`;
    } catch (e){
      return "-";
    }
  }

  openAddContactModal(type) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addPropertyContact',
      size: 'md',
      resolve: {
        config: function() {
          return {
            type: type
          }
        }
      }
    });

    modalInstance.result.then(newContact => {

        that.property.contacts.push(newContact);

        that.PropertyService.update({id: that.propertyId}, this.property, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add contact to property');
        });
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.PropertyService.addAttachments({id: that.propertyId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to property');
        });
      },
      function () { /* cancel */ }
    );

  }

  createWorkOrder() {
    this.$state.go('workorder-ticket-edit',{propertyId: this.propertyId});
  }

  createViolation() {
    this.$state.go('violations-ticket-edit',{propertyId: this.propertyId});
  }

  getContactType(contact) {
    return contact.type.split("-").join(" ");
  }
}

export default angular.module('conduu.propertyShow', [uiRouter])
  .config(routes)
  .component('propertyShow', {
    template: require('./property-show.html'),
    controller: PropertyShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-show/property-show.component.js